import axios from 'axios';
import { Message } from 'element-ui';
import userService from '@/components/service/UserService';
import { filterObj } from '@/utils/index';

const instance = axios.create({
  baseURL: (process.env.NODE_ENV === 'development') ? process.env.BASE_API : (window.location.pathname),
  timeout: 60 * 1000,
  withCredentials: true,
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 过滤参数中为空的属性
    if (config.params) config.params = filterObj(config.params);
    if (config.data) config.data = filterObj(config.data);
    // `config.requestToken = false`时，接口请求不需要添加请求头`access-token`
    const token = userService.getToken();
    if (config.requestToken !== false && token) {
      config.headers['access-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 1、接口请求成功code集合
 * 大部分时候res.code = 0，说明请求成功
 * 特殊情况处理：
 *    res.code = 501，添加/修改流设备时，存在流地址正确性的检测，会返回501，表示接口调用成功同时提醒用户流有问题。
 */
const successCode = [0, 501];

// 响应拦截器
instance.interceptors.response.use((response) => {
  // 后台设定token连续X时间内不操作则会退出登录，即每次请求接口后需要保存最新的token
  if (response.headers['access-token-x']) {
    userService.setToken(response.headers['access-token-x'])
  }
  // 对响应数据做点什么
  const res = response.data;
  if (typeof (res.code) === 'number' && !successCode.includes(res.code)) {
    // `disableCodeMsg` 是否提示用户错误code消息
    !response.config.disableCodeMsg && Message.error(res.msg);
    return Promise.reject(response);
  }
  // 文件类型请求（responseType: blob）特殊处理 
  if (response.config.responseType === 'blob') {
    const cd = response.headers['content-disposition'];
    if (cd) {
      return {
        filename: decodeURIComponent(cd.split('filename*=utf-8')[1]),
        file: res,
      }
    }
    return res;
  }
  // md文件（responseType: md）特殊处理
  if (response.config.responseType === 'md') {
    return res;
  }
  return res.data;
}, (error) => {
  const res = error.response;
  if (res) {
    // 后台设定token连续X时间内不操作则会退出登录，即每次请求接口后需要保存最新的token
    if (res.headers['access-token-x']) {
      userService.setToken(res.headers['access-token-x'])
    }
    // 对响应错误做点什么
    switch(res.status) {
      case 401:
        // Message.error('身份验证失败，请重新登录');
        userService.clearUserInfo();
        window.location.reload();
        break;
      case 404:
        Message.error('无法找到所请求的资源');
        break;
      default:
        Message.error((res&&res.data&&res.data.msg) || '数据请求异常');
    }
  }
  return Promise.reject(error);
});

export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js